export const DEVELOPMENT_MODE = 'development';

export const LOCAL_ENVIRONMENT = 'local';
export const DEVELOPMENT_ENVIRONMENT = 'development';
export const EPHEMERAL_ENVIRONMENT = 'ephemeral';
export const INTEGRATION_HEADLESS_ENVIRONMENT = 'integration-headless';
export const INTEGRATION_ENVIRONMENT = 'integration';
export const PERFORMANCE_ENVIRONMENT = 'performance';
export const STAGE_ENVIRONMENT = 'stage';
export const PRODUCTION_ENVIRONMENT = 'production';
